
import AppConstants from '@/shared/app/model/AppConstants';
import Base from '@/shared/app/ui/Base.vue';
import Component from 'vue-class-component';

@Component
export default class Dish extends Base {
  get name() {
    return this.key('name')?.toString() || '';
  }

  get nameEnglish() {
    return this.key('name_english')?.toString() || '';
  }

  get sides() {
    return this.key('sides')?.toString() || '';
  }

  get price() {
    return this.formatPrice(this.key('price'));
  }

  get price2() {
    return this.formatPrice2(this.key('price2'));
  }

  get carbonscore() {
    return this.key('carbonscore')?.toString() || '';
  }

  get allergens() {
    return this.key('allergens')?.toString() || '';
  }

  get ingredients() {
    return this.key('ingredients')?.toString() || '';
  }

  get origins() {
    return this.key('origins')?.toString() || '';
  }

  get energy() {
    return this.key('energy')?.toString() || '';
  }

  key(keyName: string) {
    return this.dataset('dishes')[`dish${this.index}_${keyName}`];
  }

  get index(): number {
    return Number(this.config.index) || AppConstants.DEFAULT_DISH_INDEX;
  }
}
